import { captureException } from '@sentry/browser';

export function getOrderStateText({ state, isLate, acknowledgement }) {
  if (!state) {
    return '';
  }

  const _capitalizeFirstWord = (text) => text.charAt(0).toUpperCase() + text.slice(1);

  switch (state) {
  case 'draft':
    return _capitalizeFirstWord(state);
  case 'delivered':
    if (isLate) {
      return 'Delivered Late';
    } else {
      return _capitalizeFirstWord(state);
    }
  case 'scheduled':
    if (isLate) {
      if (acknowledgement === 'approved') {
        return 'Waiting';
      }
      return 'Waiting for Del.';
    } else {
      return _capitalizeFirstWord(state);
    }
  case 'not-delivered':
    return 'Missed Del.';
  case 'ready':
    return 'Pending';
  case 'closed':
    return 'Cancelled';
  default:
    captureException(`OrderStatusText | Unknown order state: ${state}`);
    return _capitalizeFirstWord(state);
  }
}
